import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import useScrollReveal from "@/hooks/useScrollReveal";

export default function PageLayout({ children, className = "" }) {
  const location = useLocation();
  useScrollReveal([location.pathname]);

  return (
    <div className="min-h-screen" style={{ backgroundColor: "var(--mp-paper)" }}>
      <div className="grain-overlay" />
      <Navbar />
      <main className={`pt-20 lg:pt-24 page-enter ${className}`} key={location.pathname}>
        {children}
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
